// Modules
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

// Services
import MonitoringAlert from 'services/data/monitoring-alert';

// Hooks
import { useTriageMutation } from 'modules/triage/hooks/useTriageMutation';

// Components
import TriageItem from './triage-item';
import { MonitoringAlertDetails, Claim, Resolve } from './triage-options';


export default function MonitoringAlertItem({ item: monitoringAlert, currentUser, onDashboard, ...passed }) {
  const { update, claim } = useTriageMutation({ type: 'monitoringalert', currentUser });

  const { open } = MonitoringAlert;
  const claimed = !_.isEmpty(monitoringAlert.claimedBy);
  const ok = monitoringAlert.monitoringAlertStatus === 'Ok';
  const needsResolution = _.includes(['Active', 'After Hours'], monitoringAlert.status) && ok;
  const url = `https://monitor.praece.com/history.php?itemids[0]=${monitoringAlert.itemId}&action=showlatest`;
  let prefix = '';

  if (monitoringAlert.autoResolved) prefix = '(AR) ';
  if (ok && !monitoringAlert.autoResolved) prefix = '(OK) ';

  const text = prefix + monitoringAlert.trigger;
  const payload = onDashboard ? text : <a href={url} target="_blank">{text}</a>;

  return (
    <TriageItem
      {...passed}
      itemOrigin={monitoringAlert.hostname}
      payloadOrStatus={payload}
      currentUser={currentUser}
      onDashboard={onDashboard}
      updateTriageItem={update}
      triageItem={monitoringAlert}
    >
      <MonitoringAlertDetails monitoringAlert={monitoringAlert} />

      { !open && (!claimed || needsResolution) &&
        <div className="triage-primary-options">
          { !claimed && <Claim triageItem={monitoringAlert} claim={claim} /> }
          { needsResolution && <Resolve triageItem={monitoringAlert} updateTriageItem={update} /> }
        </div>
      }
    </TriageItem>
  );
}

MonitoringAlertItem.propTypes = {
  item: PropTypes.shape({
    open: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.bool
    ]),
    setOpen: PropTypes.func
  }),
  currentUser: PropTypes.object.isRequired,
  onDashboard: PropTypes.bool
};
